import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';
import { GithubIcon, NsList, TwitterIcon } from '../customElements';

const EexternalLinkedListStyle = styled(NsList)`
  grid-area: external;
  justify-self: start;
  align-self: center;
  ${media.lessThan('medium')`
    justify-self: center;
  `}
  height: 2rem;
`;
const EexternalLinkedListItem = styled.li`
  display: block;
  margin: 0 1rem;
  display: inline-block;
  a {
    color: var(--font-color);
    display: inline-block;
  }
  color: var(--font-color);
`;

export const EexternalLinkedList = () => (
  <EexternalLinkedListStyle>
    <EexternalLinkedListItem>
      <a href="https://github.com/kkngsm">
        <GithubIcon />
      </a>
    </EexternalLinkedListItem>
    <EexternalLinkedListItem>
      <a href="https://twitter.com/kkngsm">
        <TwitterIcon />
      </a>
    </EexternalLinkedListItem>
  </EexternalLinkedListStyle>
);
